import React from 'react'
import { WrappedComponentProps, injectIntl } from 'react-intl'

interface IntlConsumerProps {
  readonly children: (props: WrappedComponentProps) => React.ReactElement<any>
}

function Consumer({
  intl,
  children
}: IntlConsumerProps & WrappedComponentProps) {
  return children({ intl })
}

export const I18nConsumer = injectIntl(Consumer)
I18nConsumer.displayName = 'I18nConsumer'
